export default {"src":"/_next/static/media/EHAQA-main.12383871.svg","height":37,"width":38};